import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Toolbar,
    Typography,
    Container,
    Paper,
} from '@material-ui/core';

import { Assets } from 'enums';
import ResponsiveIframe from './ResponsiveIframe';
import { branding } from '../../config/portalBranding';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        marginBottom: theme.spacing(3),
    },
    content: {
        padding: theme.spacing(3),
        textAlign: 'left',
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        alignItems: 'center',
    },
    logo: {
        width: '100%',
        maxWidth: '400px', // Adjust the maximum width as needed
    },
}));

function TermsHi() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6">नियम और शर्तें</Typography>
                </Toolbar>
            </AppBar>
            <Container maxWidth="lg" className={classes.content}>
                <Paper className={classes.paper}>
                    <img alt="Logo" src={branding.logo || Assets.Logo2} className={classes.logo} />
                    <Typography variant="h4" gutterBottom>
                        नियम और शर्तें
                    </Typography>
                    <ResponsiveIframe url="https://onedrive.live.com/embed?resid=D3E7C876FD6A52A1%21134&authkey=!AKJn-XZDwpgSuPY&em=2"/>
                </Paper>
            </Container>
        </div>
    );
}

export default TermsHi;
